//問い合わせ確認画面
import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PageParam } from "./Inquiry";
import { HttpPostData, JumpPage } from "../../common/Util";
import { ResponseParamBase } from "../../common/Types"
import { LoginStateConext } from "../../context/AuthContext";
import { TitleParamContext } from "../../context/TitleContext";
import { MessageParam } from "../Message";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";
import confirm from  "../../css/confirm.module.css";

type ResponeParam = ResponseParamBase & {

}

export const Confirmation = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const titleConext = useContext(TitleParamContext);
    const loginStateConext = useContext(LoginStateConext);
    const beforePageParam = location.state as PageParam;
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <>
            <section className={market.marketArea}>
                <p style={{ marginLeft: "50px" }} className={base.messageFont}>以下の内容で送信します。</p>
            <section className={confirm.OutSideArea}>
                <div className={confirm.InSideArea}>
                    <h1>お問い合わせ</h1>
                    <h2>お問い合わせのジャンル</h2>
                    <h3>{beforePageParam.title}</h3>
                    <input type="hidden" value="@ViewBag.Title" name="title" />
                    <h2>お問い合わせ内容</h2>
                    <h3>{beforePageParam.contents}</h3>
                </div>
            </section>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>                    
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage<PageParam>("/MyPage/Inquiry", beforePageParam, "", navigate); }}>戻る</button>
                            <button className={market.marketButton}
                                type="submit"
                                onClick={async (e) => {
                                    await HttpPostData<ResponeParam>("/usermanager/sendsupportmessage", { title: beforePageParam.title, contents: beforePageParam.contents, email: loginStateConext.loginInfo.email }, setLoading)
                                        .then(response => {
                                            JumpPage<MessageParam>("Complete", { message: response.data.message, displayButton: true }, "", navigate);
                                        });
                                }}
                                disabled={loading}
                        >送信</button>
                        <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                    </div>
                </div>
                </section >
            </section>
        </>
    );
}